import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Attach auth refresh/retry interceptors to axios before any form mounts.
import './services/api';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const app = <App />;
root.render(process.env.NODE_ENV === 'development' ? app : <React.StrictMode>{app}</React.StrictMode>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
